import logUtil from 'utils/log'
import isNavigatingProductSelect from 'modules/product/redux/selectors/is-navigating-to-product'
import goBackQuickShopAction from 'containers/Sidebar/components/Content/actions/go-back'
import scrollToTopDomUtil from 'utils/dom/scroll-to-top'
import getCurrentIdProductSelect from 'modules/product/redux/selectors/get-current-id'
import getByIdProductSelector from 'modules/product/redux/selectors/get-by-id'
import updateHandleUrlProductUtil from 'modules/product/utils/update-handle-url'
import getHashLocationUtil from 'utils/location/get-hash'
import { CART_HASH_VALUE_ACTION } from 'modules/cart/constants'
import runAfterDelayTimingUtil from 'utils/timing/run-after-delay'
import hasMoreThanOneQuickShopHistoryItemProductSelect from 'modules/product/redux/selectors/has-more-than-one-quick-shop-history-item'
import getPreviousHistoryItemProductsSelect from 'modules/product/redux/selectors/get-second-last-item-from-history'

const handlePopStateProductsPageAction = () => {
  return async (dispatch, getState) => {
    const isNavigating = isNavigatingProductSelect(getState())
    if (isNavigating) {
      logUtil('handlePopStateProductsPageAction').debug('[noop] navigating')
      return
    }

    const hash = getHashLocationUtil()
    if (
      hash &&
      !hash.includes(CART_HASH_VALUE_ACTION.OPEN_QUICK_SHOP_PRODUCT_SIDEBAR)
    ) {
      logUtil('handlePopStateProductsPageAction').debug('[noop] there’s a hash')
      return
    }

    if (!hasMoreThanOneQuickShopHistoryItemProductSelect(getState())) {
      logUtil('handlePopStateProductsPageAction').debug('[noop] not more than one history item')
      return
    }

    const productId = getCurrentIdProductSelect(getState())
    /**
     * @type {QuickShopHistoryItem}
     */
    const previousHistoryItem = getPreviousHistoryItemProductsSelect(getState())
    logUtil('handlePopStateProductsPageAction').debug('previousHistoryItem=', previousHistoryItem)
    const previousProductId = previousHistoryItem?.productId
    const hasChanged = (
      previousProductId &&
      productId !== previousProductId
    )

    if (!hasChanged) {
      logUtil('handlePopStateProductsPageAction').debug('[noop] not changed')
      return
    }

    const product = getByIdProductSelector(previousProductId)(getState())
    const debugProps = {
      productId,
      hasChanged,
      previousProductId,
      isNavigating,
      product
    }
    logUtil('handlePopStateProductsPageAction').debug('[done] debugProps=', debugProps)

    if (product) {
      updateHandleUrlProductUtil({ handle: product.handle })
    }

    dispatch(goBackQuickShopAction())

    await runAfterDelayTimingUtil(0)
    scrollToTopDomUtil()
  }
}

export default handlePopStateProductsPageAction
